import { spiritoryWebApi } from '@/lib/axios/SpiritoryWebApi/spiritoryWebApi';

export default async function doPressReleaseSubscription(email: string) {
  try {
    await spiritoryWebApi.post('/press/release-subscription', {
      email,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
}
